import { CONFIGURATOR_PARAM_NAME, CONFIGURATOR_PARAM_VALUE_ON, CONFIGURATOR_SOURCE_PARAM_VALUE, SOURCE_PARAM_NAME, } from '@yme/common/constants';
import { ACC_ENV_KEY, PROD_ENV_KEY, TEST_ENV_KEY, localeMapping, reqExpForReplaceNumbers, reqExpForReplaceProjectEnv, CTA_ENDPOINT_TYPE, } from './constants';
export const getProjectKey = (value) => {
    const projectKey = value.toLowerCase();
    if (!projectKey.includes(ACC_ENV_KEY) && !projectKey.includes(TEST_ENV_KEY)) {
        return projectKey;
    }
    const projectKeySplitArr = projectKey.split('-');
    return projectKeySplitArr
        .map((item, index) => {
        if (projectKeySplitArr.length === index + 1) {
            return item.replace(reqExpForReplaceNumbers, '');
        }
        return item;
    })
        .join('-')
        .replace(reqExpForReplaceProjectEnv, PROD_ENV_KEY);
};
export const prepareLocale = (locale, projectKey) => {
    return localeMapping[projectKey] || locale.replace('EU', 'GB');
};
export const getTestRideLinksEndpoints = (data) => {
    if (!data) {
        return [];
    }
    return Object.values(data).map(({ masterSku, linkForTestRide }) => {
        const url = new URL(linkForTestRide, window.location.origin);
        url.searchParams.set(CONFIGURATOR_PARAM_NAME, CONFIGURATOR_PARAM_VALUE_ON);
        url.searchParams.set(SOURCE_PARAM_NAME, CONFIGURATOR_SOURCE_PARAM_VALUE);
        return {
            type: CTA_ENDPOINT_TYPE.testRide,
            sku: masterSku,
            url: url.toString(),
        };
    });
};
